import React, { useEffect ,useState } from 'react';

//--
import './ImpaasContainer.css';

import * as utils from './_utils/utils.js'

//! *** Use case components ***
import ConvertApp from './convert/ConvertApp.tsx';
import ResizeApp from './resize/ResizeApp.tsx';
import TransformApp from './transform/TransformApp.tsx';
import CropApp from './crop/CropApp.tsx';
import OcrApp from './ocr/OcrApp.tsx';

const CommingSoon = () => <div>Coming soon!</div>;

//! DEVNOTEs
    //! TODO
    //? how to get connected user from django => params (queueTime)
    //? how to connect a ref to django form (to hook form subit rather than doc submit, which doesn't work when onClick is called)

//! *** Main Impaas Container ***
const ImpaasContainer = () => {

//-- TABs
    const [selectedTab, setSelectedTab] = useState('Convert');

//-- STATEs

    //-- changes
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

    const onUnsavedChanges = (unsaved) => {
        setHasUnsavedChanges(unsaved);
    };

    const onBeforeUnload = (event) => {
        if( hasUnsavedChanges ) {
            const confirmationMessage = "You have unsaved changes. Are you sure you want to leave?";
            event.preventDefault();
            event.returnValue = confirmationMessage; //! For most browsers
            return confirmationMessage; //! For Firefox
        }
    };

    useEffect(() => {
        window.addEventListener('beforeunload', onBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
        };

        //! NB intentionally omitting some stable dependencies
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasUnsavedChanges]);

    /* const handleSubmit = async (e) => {
        // const userConfirmed = window.confirm("Submitting!");

        e.preventDefault();
        const formData = new FormData(formRef.current);

        const response = await fetch('/my-form/', {
            method: 'POST',
            body: formData,
        });

        if (response.ok) {
            const result = await response.json();
            console.log('Form submitted successfully:', result);
        } else {
            const errorData = await response.json();
            console.error('Form submission errors:', errorData.errors);
        }
    }; */

    const onSubmit = (event) => { //! NB BUG if starting submit from code, not triggered 
        /* if( !imageSource ) { //! NB not working for some reason, imageSource / imageUrl = null !?
            event.preventDefault(); // Prevent form submission if no file is selected
            alert("[internal] No file selected.");
            return false; // Prevent default form submission
        } */
        
        setHasUnsavedChanges(false);
        return true;
    };

    useEffect(() => {
        document.addEventListener('submit', onSubmit);

        return () => {
            document.removeEventListener('submit', onSubmit);
        };
    }, []); // Empty dependency array to run once on mount

//-- IMAGE
    const [imageInfo, setImageInfo] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const [imageSource, setImageSource] = useState(null);

    const onUpload = (file ,url ,source) => {
        //! on image uploaded, called from onFileUpload when upload is done

        if( !file ) { //! empty or error
            if( url ) {
                setImageInfo({ header: "error: " + url });
            }

            return;
        } 

        const img = new Image();
        img.src = source;

        img.onload = () => {
            const width = img.width;
            const height = img.height;
    
            setImageUrl(url);
            setImageSource(source);
            setImageInfo({ 
                header : "'" + file.name.toUpperCase() + "' (" + width + "x" + height + ")" //? => format
                ,name : file.name
                ,width : width
                ,height : height
            });
        };
    };

    const onFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        //! triggered when input file is clicked

        const file = event.target.files?.[0];

        if( !file ) {
            onUpload( null ,"" ,null );
            return;
        }

        try {
            utils.setImageConvert( file ,onUpload );
        } catch(err) {
            onUpload( null ,err.message ,null );
            return;
        }
    };

    const onImageUpload = (event: React.ClickEvent<HTMLButtonElement>) => {
        //! call to start upload (trigger hidden file input)
        document.getElementById('uploadedFileID').click();
    }

    //-- download
    const [isQueuing,setIsQueuing] = useState(false);
    //+ queueTime //NB depend on user

    const adviseDownload = () => {
        setHasUnsavedChanges(false);
        return true;
    }

    const adviseQueuing = (running) => {
        setIsQueuing(running);
    }
    
//-- FORMATs
    const [selectedFormat, setSelectedFormat] = useState('');

    const onFormatSelect = (value) => {
        //! NO onUnsavedChanges(true); //=> its global now
        setSelectedFormat(value)
    };

//-- TABs
    const renderComponent = () => {
        const componentProps = {
            states: {
                hasChanges: hasUnsavedChanges,
                onChanges: onUnsavedChanges,
                isQueuing: isQueuing,
                adviseDownload: adviseDownload,
                adviseQueuing: adviseQueuing,
            },
            image: {
                info: imageInfo,
                url: imageUrl,
                source: imageSource,
                onUpload: onImageUpload,
            },
            format: {
                name: selectedFormat,
                onSelect: onFormatSelect,
            },
        };

        switch (selectedTab) {
            default:
                return <CommingSoon />;

            case 'Convert':
                return <ConvertApp {...componentProps}/>;
            case 'Crop':
                return <CropApp {...componentProps}/>;
            case 'Resize':
                return <ResizeApp {...componentProps}/>;
            case 'Transform':
                return <TransformApp {...componentProps}/>;
            case 'OCR':
                return <OcrApp {...componentProps}/>;
                    
            //=> info, convert, crop ,resize ,transform ,tune ,enhance ,ocr ... filter ,annotate ,redact || denoise, super-res || ai ...
            // REDACT => blur, stegano, watermark, sticker
        }
    };

    const onTabChange = (tab) => {
        //! TODO: if tab change is unsuccesful, new tab visual should not be selected

        if( hasUnsavedChanges ) {
            const userConfirmed = window.confirm("There are unsaved changes, are you sure you want to leave this tab?");

            if( !userConfirmed) { 
                return; // User clicked "Cancel", so we exit the function
            }
        }

        setHasUnsavedChanges(false); // Reset unsaved changes since we're switching tabs
        setSelectedTab(tab);
    };

    //--
    return (
        <div className="impaas-container">
            <div className="tab-buttons">
                <button type="button" onClick={() => onTabChange('Info')}>Info</button>
                <button type="button" onClick={() => onTabChange('Convert')}>Convert</button>
                <button type="button" onClick={() => onTabChange('Crop')}>Crop</button>
                <button type="button" onClick={() => onTabChange('Resize')}>Resize</button>
                <button type="button" onClick={() => onTabChange('Transform')}>Transform</button>
                <button type="button" onClick={() => onTabChange('OCR')}>OCR</button>
                { /* <button type="button" onClick={() => onTabChange('Tune')}>Tune</button>
                <button type="button" onClick={() => onTabChange('Filter')}>Filter</button>
                <button type="button" onClick={() => onTabChange('Enhance')}>Enhance</button>
                <button type="button" onClick={() => onTabChange('Annotate')}>Annotate</button>
                <button type="button" onClick={() => onTabChange('Redact')}>Redact</button>
                <button type="button" onClick={() => onTabChange('Denoise')}>Denoise</button>
                <button type="button" onClick={() => onTabChange('Super-Resolution')}>Super-resolution</button> 
                <button disabled type="button" onClick={() => onTabChange('AI')}>AI</button> */ }
            </div>
            <div className="tab-content">
                <input type="hidden" id="useCaseID" name="use_case" value={selectedTab}></input> 
                <input type="hidden" name="output_format" value={selectedFormat} />
                <input type="file" id="uploadedFileID" name="uploaded_file" class="hidden" onChange={onFileUpload} />
                {renderComponent()}
            </div>
        </div>
    );
};

export default ImpaasContainer;